module.exports = __webpack_public_path__ + "static/media/notification_reminder_icon.4329b2fc.svg";